import { render, staticRenderFns } from "./AtencionDiagnosticos.vue?vue&type=template&id=69ea6874"
import script from "./AtencionDiagnosticos.vue?vue&type=script&lang=js"
export * from "./AtencionDiagnosticos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports